import styled from '@emotion/styled';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down.svg';
import { TextStyle } from 'styles/variables/mixins';
import { Colors } from 'styles/variables/colors';
import { Variables } from 'styles/variables/variables';
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import { ReactComponent as HourglassIcon } from 'assets/icons/hourglass.svg';
import { ReactComponent as CircleIcon } from 'assets/icons/B2B/circle.svg';
import { ReactComponent as FailIcon } from 'assets/icons/cross-simple.svg';

const { assistant, montserrat } = Variables;
const { linkBlue } = Colors;
export const Dropdown = styled.div`
    ${TextStyle({ fontSize: '16px', fontWeight: '400' })}
    height: 40px;
    border: 2px solid ${Colors.lightGray};
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    line-height: 1;
    width: inherit;
    padding: 9px 12px;
    box-sizing: border-box;
    fill: ${Colors.darkGray};
    transition: all 110ms ease;
    background: ${Colors.white};
    outline: none;
    margin-bottom: 0.8rem;
    cursor: pointer;
`;

export const DropdownContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: inherit;
`;

export const DropdownIcon = styled(ArrowDownIcon)`
    fill: inherit;
    width: 10px;
    margin-left: 14px;
`;

//for notifications/notes
export const BottomContainer = styled.div`
    ${TextStyle({ fontSize: '16px', fontWeight: '300', color: '#282828', fontFamily: assistant })};
    letter-spacing: 0.2px;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;
export const CreatedAt = styled.div`
    ${TextStyle({ fontSize: '15px', fontWeight: '300', color: '#282828', fontFamily: assistant })};
    letter-spacing: 0.2px;
    font-style: italic;
    white-space: nowrap;
`;

export const Message = styled.div`
    ${TextStyle({ fontSize: '16px', fontWeight: '600', fontFamily: assistant })};
    display: inline-block;
    letter-spacing: 0px;
    line-height: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 25px);
    display: -webkit-box; /* Required for -webkit-line-clamp to work */
    display: -webkit-box; /* Required for line-clamp to work */
    -webkit-box-orient: vertical; /* Ensure vertical layout */
    -webkit-line-clamp: 2; /* Limit to two lines for WebKit browsers */
    -moz-line-clamp: 2; /* Limit to two lines for Firefox */
    -o-line-clamp: 2; /* Limit to two lines for Opera */
    line-clamp: 2; /* Limit to two lines */
`;

export const NoteTitle = styled.div`
    ${TextStyle({ fontSize: '16px', fontWeight: '500' })};
    max-width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    letter-spacing: 0px;
`;

export const TopContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const NotificationsContainer = styled.ul<{ mobile: boolean; open: boolean }>`
    max-height: ${({ mobile, open }) =>
        mobile && open ? 'calc(100vh - 280px)' : open ? '18rem' : '0'};
    overflow-y: auto;
    width: 100%;
    margin-bottom: ${({ open }) => (open ? '1rem' : '0')};
    /* opacity: ${({ open }) => (open ? '1' : '0')}; */
    transition-property: max-height, margin-bottom;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
`;

export const NotificationContainer = styled.div`
    border-radius: 8px;
    border: 1px solid #f3f4f6ff;
    box-shadow: 0px 10px 20px -15px #171a1f;
    display: flex;
    flex-direction: column;
    padding: 1rem 1.5rem 1rem 1.5rem;
    margin-bottom: 1rem;
    width: 100%;

    :hover {
        background-color: ${Colors.inputBorder};
        border: 1px solid ${Colors.inputBorder};
        cursor: pointer;
    }
`;

export const TrashContainer = styled.div`
    text-align: end;
    margin-bottom: 0.5rem;
    cursor: pointer;
`;

export const ClearAllButton = styled.span`
    ${TextStyle({ fontSize: '15px', fontWeight: '500', fontFamily: assistant })};
    padding: 0 12px;
    height: 36px;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #dee1e6ff;
    border-radius: 4px;
    box-shadow: 0px 10px 20px -15px #171a1f;
    margin: 0rem 0rem 0.8rem 0rem;
    white-space: nowrap;
    line-height: 1.2;
    letter-spacing: 0.2px;

    :hover {
        cursor: pointer;
        color: #262a33ff;
        background: #ffffffff;
    }
`;

export const Line = styled.div`
    border-right: 2px solid ${Colors.darkGray};
    height: 50px;
    width: 50%;
`;

export const Title = styled.div`
    ${TextStyle({ fontSize: '15px', fontWeight: '500' })};
    line-height: 1.2;
    letter-spacing: -0.2px;
    overflow: hidden;
    display: inline-block;
    /* white-space: nowrap; */
    text-overflow: ellipsis;
    margin-bottom: 4px;
    margin-top: 6px;
`;

export const BlueWord = styled.span`
    color: #00bdd6ff;
`;

// for tickets
export const TicketsContainer = styled.div<{ mobile: boolean; open: boolean }>`
    max-height: ${({ mobile, open }) =>
        mobile && open ? 'calc(100vh - 280px)' : open ? '20rem' : '0'};
    overflow-y: auto;
    border-radius: 4px;
    border: ${({ open }) => (open ? '1px solid #f3f4f6ff' : 'none')};
    margin-bottom: ${({ open }) => (open ? '1rem' : '0')};
    box-shadow: 0px 10px 20px -15px #171a1f;
    /* opacity: ${({ open }) => (open ? '1' : '0')}; */
    transition-property: max-height, margin-bottom;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
`;

export const ListTable = styled.div`
    ${TextStyle({
        fontSize: '16px',
        fontWeight: '400',
        color: '#282828',
        fontFamily: Variables.assistant,
    })};
    line-height: 20px;
    border-radius: 8px;
    border: 1px solid #f3f4f6ff;
    box-shadow: 0px 10px 20px -15px #171a1f;
    /* overflow-y: auto; */
    /* height: 500px; */
    width: 100%;
    /* overflow-x: auto; */

    & > div > div {
        border-bottom: 1px solid #f5f5f5;
    }

    & > div:last-child div,
    & > div:first-child div {
        border-bottom: none;
    }
`;

type DropdownProps = {
    isActive?: boolean;
};

export const LeftDropdown = styled.div<DropdownProps>`
    outline: none;
`;

export const Container = styled.div<{ mobile?: boolean }>`
    background: ${Colors.white};
    width: ${({ mobile }) => (mobile ? '360px' : '466px')};
    border: 1px solid #8353e2ff;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    border-radius: 4px;
    padding: 1rem;
`;

export const Row = styled.div`
    ${TextStyle({ fontSize: '16px', fontWeight: '700', color: Colors.gray })};
    display: flex;
    align-items: center;
    line-height: 1.2;
`;

export const NotifyContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    border-radius: 4px;
    padding: 0.5rem;
`;

//for visa status
export const StatusContainer = styled.div<{ open: boolean }>`
    max-height: ${({ open }) => (open ? '25rem' : '0')};
    overflow-y: hidden;
    border-radius: 4px;
    border: ${({ open }) => (open ? '1px solid #f3f4f6ff' : 'none')};
    box-shadow: 0px 10px 20px -15px #171a1f;
    transition-property: max-height;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
`;

export const IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 70px;
`;
export const StatusLine = styled.div`
    border-right: 1.5px solid ${Colors.darkGray};
    height: 18px;
    width: 50%;
`;

export const Name = styled.p`
    margin-top: 0.5rem;
`;

export const Stage = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: fit-content;
    font-family: ${montserrat};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: ${Colors.darkGray};
`;

export const StageIcon = styled.div`
    height: 32px;
    width: 32px;
    min-width: 32px;
    border-radius: 50%;
    background-color: ${Colors.green};
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
`;

export const StageIconIdle = styled(StageIcon)`
    background: ${Colors.blue};
`;

export const StageIconInProcess = styled(StageIcon)`
    background: ${Colors.orange};
`;

export const StageIconDanger = styled(StageIcon)`
    background: ${Colors.red};
`;

export const Stepper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StatusTitle = styled.h3`
    letter-spacing: -1px;
    margin-bottom: 1rem;
    font-weight: 700;
`;

//icons
export const Check = styled(CheckIcon)`
    fill: ${Colors.white};
`;

export const Fail = styled(FailIcon)`
    fill: ${Colors.white};
`;

export const Idle = styled(CircleIcon)`
    path {
        fill: ${Colors.white};
    }
`;

export const Hourglass = styled(HourglassIcon)`
    fill: ${Colors.white};
`;

//for assign apps popover
export const Warning = styled.p`
    ${TextStyle({
        fontSize: '16px',
        fontWeight: '400',
        color: Colors.red,
        fontFamily: Variables.assistant,
    })};
`;

export const AgentSection = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const Link = styled.a`
    color: ${linkBlue};
`;
